import { useSelector } from 'react-redux'
import RootState from 'store/state'

export default function useMetrics(): RootState['metrics'] {
    const metrics = useSelector<RootState, RootState['metrics']>(({ metrics }) => metrics)

    return metrics
}
